<template>
    <div class="reply-container" v-if="showReply">
        <Textarea v-model:value="replyForm.content"
                  @keydown.enter="submitReply"
                  :maxlength="255"
                  :auto-size="{
                      minRows: 1
                  }"
                  placeholder="回复内容，Enter提交"
                  class="comment-input"></Textarea>
    </div>
    <div v-if="list.data.length" class="reply-list" :class="{
        show: props.show
    }">
        <div class="comment-list">
            <div class="comment" v-for="reply in list.data">
                <Avatar :user="reply.user" class="avatar-container">
                    <img :src="reply.user.avatar.url" alt="" class="avatar">
                </Avatar>
                <div class="comment-info">
                    <div class="name-line">
                        <div class="username">{{ reply.user.nickname }}</div>
                        <div class="date">{{ dayjs(reply.created_at).format('YYYY-MM-DD HH:mm') }}</div>
                    </div>
                    <div class="content-container">
                        <div class="content">{{ reply.content }}</div>
                        <div class="action-container">
                            <Link v-if="reply.user.id === usePage().props?.auth?.user?.id"
                                  @click="onDeleteClick(reply)"
                                  class="action">删除
                            </Link>
                            <!--                            <Link v-else class="action">回复</Link>-->
                        </div>
                    </div>
                </div>
            </div>
            <PaginationForApi v-model:list="list"
                              :url="route('api.work.comment.replies',{comment: props.commentId})"></PaginationForApi>
        </div>
    </div>

</template>

<script setup lang="ts">
import {getCurrentInstance, ref, watch} from "vue";
import PaginationForApi from "@/Components/Common/PaginationForApi.vue";
import http from "@/utils/http";
import {useForm, usePage} from "@inertiajs/vue3";
import {Textarea} from "ant-design-vue"
import {route} from "@/utils/common";
import dayjs from "dayjs";
import Avatar from "@/Components/Avatar.vue";
import Link from "@/Components/Link.vue";
import {message} from "@/utils/modal";

const props = defineProps<{
    list: any,
    commentId: any,
    workId: any,
    show: boolean
}>()

const list = ref(props.list)
const showReply = ref(false)

watch(() => props.list, () => {
    showReply.value = false
    list.value = props.list
})

const replyForm = useForm({
    content: '',
    pid: null,
})
const ins = getCurrentInstance()

const reloadComment = async () => {
    const comment = await http.get(route('api.work.comment.find', {comment: props.commentId}))
    list.value = comment.replies_for_pagination
}

const submitReply = async () => {
    replyForm.pid = props.commentId
    await http.post(route('api.work.comment.create', {work: props.workId}), replyForm.data())

    replyForm.content = ''
    await reloadComment()
}

const onDeleteClick = (item: any) => {
    message({
        content: '确定删除此回复',
        btns: [
            {
                text: '删除',
                async onClick(v) {
                    await http.delete(route('api.work.comment.destroy', {comment: item.id}))
                    list.value.data = list.value.data.filter((v) => v.id !== item.id)

                    v.value = false
                }
            }
        ]
    })

}

defineExpose({
    showReply() {
        showReply.value = !showReply.value
    },
})

</script>

<style scoped lang="less">

.reply-container {
    .comment-input {
        margin-top: 10px;
        border-radius: 3px;
        padding-left: 60px;
    }
}

.reply-list {
    margin-top: 20px;
    background: #F6F6F6;
    padding: 16px 0 16px 60px;
    max-height: 50px;
    overflow: hidden;
    transition: all .3s;
    position: relative;

    &::after {
        position: absolute;
        content: '';
        width: 100%;
        height: 20px;
        bottom: 0;
        left: 0;
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0), #FFFFFF);
        z-index: 1000;
        transition: all .3s;
    }

    &.show {
        max-height: 400px;

        &::after {
            display: none;
        }
    }

    .comment-list {
        .comment {
            margin-bottom: 20px;
            display: flex;

            .avatar-container {
                width: 46px;
                height: 46px;

                .avatar {
                    border-radius: 50%;
                }
            }

            .comment-info {
                margin-left: 20px;

                .name-line {
                    display: flex;
                    align-items: flex-end;

                    .username {
                        font-size: 14px;
                        color: #000000;
                    }

                    .date {
                        font-size: 12px;
                        color: #989898;
                        margin-left: 10px;
                    }
                }

                .content-container {
                    display: flex;
                    margin-top: 16px;
                    align-items: center;

                    .action-container {
                        .action {
                            padding: 8px;
                            font-size: 12px;
                            background: #FFFFFF;
                            border-radius: 3px;
                            margin-left: 10px;
                        }
                    }
                }
            }
        }
    }
}
</style>
